import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { CurrentPermissions } from "../types/apiTypes";

const initialState: CurrentPermissions = {
  isAllowedViewAccountPlans: null,
  isAllowedViewPlaybooks: null,
  isAllowedViewClientFullLeadInfo: null,
  isAllowedViewINFUSELeadInfo: null,

  isAllowedExportPlaybooks: null,
  isAllowedExportAccountPlans: null,
  isAllowedExportContactsAccountsList: null,

  isAllowedEditCreateNewCampaign: null,
  isAllowedEditResyncData: null,
  isAllowedEditActionsTargetTitles: null,
  isAllowedEditGenerateReports: null,
  isAllowedEditLaunchAccountAnalysis: null,

  isAllowedShareAccess: null,
  isAllowedShareViewListInternalUsers: null,

  isAllowedClientViewDemo: null,
  isAllowedPermissionsManagement: null,
};

const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setPermissions: (state, action: PayloadAction<CurrentPermissions>) => {
      return action.payload;
    },
  },
});

export const { setPermissions } = permissionsSlice.actions;

export const selectPermissions = (state: RootState) => state.permissions;

export default permissionsSlice.reducer;
